module.exports = __webpack_public_path__ + "img/img-2.0bd5160e.png";